/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ConsentBase,
    ConsentBaseToJSON,
    Employee,
    EmployeeFromJSON,
    ResponseConsent,
    ResponseConsentFromJSON,
} from '../models';

export interface UpdateUserConsentsApiUserConsentPutRequest {
    consentBase: ConsentBase;
}

/**
 *
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Get My Profile
     */
    async getMyProfileApiUserMyProfileGetRaw(): Promise<runtime.ApiResponse<Employee>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/user/my-profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => EmployeeFromJSON(jsonValue));
    }

    /**
     * Get My Profile
     */
    async getMyProfileApiUserMyProfileGet(): Promise<Employee> {
        const response = await this.getMyProfileApiUserMyProfileGetRaw();
        return await response.value();
    }

    /**
     * Get Subordinates
     */
    async getSubordinatesApiUserSubordinatesGetRaw(): Promise<runtime.ApiResponse<Employee[]>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/user/subordinates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EmployeeFromJSON));
    }

    /**
     * Get Subordinates
     */
    async getSubordinatesApiUserSubordinatesGet(): Promise<Employee[]> {
        const response = await this.getSubordinatesApiUserSubordinatesGetRaw();
        return await response.value();
    }

    /**
     * Get User Consents
     */
    async getUserConsentsApiUserConsentsGetRaw(): Promise<runtime.ApiResponse<ResponseConsent[]>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/user/consents`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ResponseConsentFromJSON));
    }

    /**
     * Get User Consents
     */
    async getUserConsentsApiUserConsentsGet(): Promise<ResponseConsent[]> {
        const response = await this.getUserConsentsApiUserConsentsGetRaw();
        return await response.value();
    }

    /**
     * Update User Consents
     */
    async updateUserConsentsApiUserConsentPutRaw(requestParameters: UpdateUserConsentsApiUserConsentPutRequest): Promise<runtime.ApiResponse<any>> {
        if (requestParameters.consentBase === null || requestParameters.consentBase === undefined) {
            throw new runtime.RequiredError('consentBase','Required parameter requestParameters.consentBase was null or undefined when calling updateUserConsentsApiUserConsentPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/user/consent`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ConsentBaseToJSON(requestParameters.consentBase),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Update User Consents
     */
    async updateUserConsentsApiUserConsentPut(requestParameters: UpdateUserConsentsApiUserConsentPutRequest): Promise<any> {
        const response = await this.updateUserConsentsApiUserConsentPutRaw(requestParameters);
        return await response.value();
    }

}
